import { Component, Input, OnInit } from '@angular/core';
import { add, milliseconds } from 'date-fns';

interface ColoringCriteria {
  duration: Duration;
  color: string;
}
interface ColoringStyle {
  color: string;
}

export const RED = 'red';
export const ORANGE = 'orange';
export const GREEN = 'green';

@Component({
  selector: 'sales-common-days-away',
  templateUrl: './days-away.component.html',
})
export class DaysAwayComponent implements OnInit {
  @Input() date: Date;
  @Input() disableColor = false;

  currentStyle: ColoringStyle;

  private coloringCriteria: ColoringCriteria[] = [
    { duration: { days: 2 }, color: RED },
    { duration: { days: 7 }, color: ORANGE },
  ];
  private defaultColor = GREEN;

  private getColor(): string {
    if (this.disableColor) {
      return;
    }
    const criteria = this.coloringCriteria.sort((a, b) => milliseconds(a.duration) - milliseconds(b.duration));

    for (const i in criteria) {
      if (Object.prototype.hasOwnProperty.call(criteria, i)) {
        const isWithinRange = this.date < add(Date.now(), criteria[i].duration);
        if (isWithinRange) {
          return criteria[i].color;
        }
      }
    }
    return this.defaultColor;
  }

  ngOnInit(): void {
    const color = this.getColor();
    this.setStyle(color);
  }

  private setStyle(color: string): void {
    this.currentStyle = <ColoringStyle>{ color: color };
  }
}
